import React from 'react';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';
import VoxelTableCheckbox from '../../../../voxel/Forms/VoxelTableCheckbox';

export interface TableCellCheckboxProps {
  selected: boolean;
}

const TableCellCheckbox: React.FC<TableCellCheckboxProps> = ({ selected }) => {
  return (
    <VoxelDataTableCell paddingClass={'checkbox'} align="center">
      <VoxelTableCheckbox checked={selected} color="primary" />
    </VoxelDataTableCell>
  );
};
export default TableCellCheckbox;
